/**
 * WOUD Theme - Main JavaScript
 * Prefix: wd-
 */

document.addEventListener('DOMContentLoaded', () => {
  // Global Initialization
  console.log('WOUD Theme initialized');

  // Example: Initialize dynamic components
  // initWdSliders();
  // initWdModals();
  initSlideshows();
  initCurrencyCountryNames();
});

/**
 * Global utility functions can be added here
 */
const wdUtils = {
  debounce: (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
};

/**
 * Header currency list: the list shows one country per currency. Without this it showed the first
 * country in the market list (Australia / Germany, changing with the language) instead of the
 * store's real country. Show the real country for each currency, in the visitor's language.
 */
const initCurrencyCountryNames = () => {
  const preferred = { AED: 'AE', QAR: 'QA', EUR: 'ES', USD: 'US' };
  let names;
  try {
    names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
  } catch (e) {
    return;
  }

  document.querySelectorAll('.wd-currency-list__item').forEach(btn => {
    const codeEl = btn.querySelector('.wd-currency-list__code');
    const currency = codeEl ? codeEl.textContent.trim().split(/\s+/)[0] : '';
    const country = preferred[currency];
    if (!country) return;

    btn.dataset.country = country;
    const label = btn.querySelector('.wd-currency-list__country');
    const name = names.of(country);
    if (label && name) label.textContent = name;
  });
};

/**
 * Slideshow Logic
 */
const initSlideshows = () => {
  const slideshows = document.querySelectorAll('.wd-slideshow');
  
  slideshows.forEach(slideshow => {
    const slides = slideshow.querySelectorAll('.wd-slideshow__slide');
    if (slides.length <= 1) return;
    
    const prevBtn = slideshow.querySelector('.wd-slideshow__arrow--prev');
    const nextBtn = slideshow.querySelector('.wd-slideshow__arrow--next');
    
    let currentIndex = 0;
    let autoplayInterval;
    const isAutoplay = slideshow.dataset.autoplay === 'true';
    const speed = parseInt(slideshow.dataset.speed) * 1000;
    
    const showSlide = (index) => {
      slides.forEach(s => s.classList.remove('is-active'));
      slides[index].classList.add('is-active');
    };
    
    const nextSlide = () => {
      currentIndex = (currentIndex + 1) % slides.length;
      showSlide(currentIndex);
    };
    
    const prevSlide = () => {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(currentIndex);
    };
    
    if (nextBtn) nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });
    
    if (prevBtn) prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoplay();
    });
    
    const startAutoplay = () => {
      if (isAutoplay) {
        autoplayInterval = setInterval(nextSlide, speed);
      }
    };
    
    const resetAutoplay = () => {
      if (isAutoplay) {
        clearInterval(autoplayInterval);
        startAutoplay();
      }
    };
    
    startAutoplay();
  });
};
